/*
 * @FilePath: /mall-fe/src/views/NewIndex/components/HeaderContent.tsx
 * @Description: 新版商城首页头部内容组件
 *
 */
import Container from 'comps/Container';
import HeaderMinCart from 'comps/HeaderMinCart';
import HeaderSearchInput from './HeaderSearchInput';
import useUrl from 'hooks/useUrl';
import AreaCascader from 'comps/AreaCascader';
import useAreaCookie from 'hooks/useAreaCookie';
import { getFirstTownOfCityCode } from 'api/user';
import shopCartBtnBg from 'images/cscec3b/shop-cart-btn-bg.png';
import { Dropdown, Menu } from 'antd';
import { isShowExposeBtn, fetchLatestExposeState } from 'api/expose';
import {
  DeviceContext,
  NavConfigContext,
  SiteContext,
  UserContext,
  CartContext,
} from 'libs/contexts';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import { Waypoint } from 'react-waypoint';
import { cls } from 'reactutils';
import { CurrentUserTypeSource } from 'libs/enums';
import BaoGuangIcon from '@/icons/home/baoguang.svg';
import EnquiryIcon from '@/icons/home/enquiry.svg';
import ComputeIcon from '@/icons/home/compute.svg';
import useToLogin from '@/hooks/useToLogin';
import SelfOperatedOrganization from '@/views/h5/my-center/features/settlement/hooks/useSelfOperatedOrganization';
import IsExternalPurchaserUsed from '@/views/h5/my-center/shared/hooks/useIsExternalPurchaserUsed';
import { amI } from '@/libs/user';
import { useRouter } from 'next/router';
import { isInDop } from 'libs/dopUtil.js';

type PortalExposeBtnProp = {
  isShowExposeBtn: boolean;
  isShowNewText: boolean;
};
/**
 *
 * @param {boolean} props.showAreaCascader 标识展示区域级联选择器
 * @returns
 */
export default function HeaderContent({ showAreaCascader = true, showCart = true }: any) {
  const site = useContext(SiteContext);
  const userInfo = useContext(UserContext);
  const { buildImgSrc } = useContext(DeviceContext);
  const navConfig = useContext(NavConfigContext);
  const { quantity } = useContext(CartContext);
  const [searchFixed, setSearchFixed] = useState(false);
  const { getPublicUrl } = useUrl();
  const { handleLogin } = useToLogin();
  const router = useRouter();
  const [portalExposeBtnProp, setPortalExposeBtnProp] = useState<PortalExposeBtnProp>({
    isShowExposeBtn: false,
    isShowNewText: false,
  });
  // 创建状态用于存储不同身份的路由
  const [purcharserRoute, setPurcharserRoute] = useState<string>('');
  const [supplierRoute, setSupplierRoute] = useState<string>('');

  useEffect(() => {
    // Waypoint初始化的时候 没有判断滚动条当前位置？
    setTimeout(() => {
      setSearchFixed(window.scrollY >= 166);
    }, 0);
  }, []);
  useEffect(() => {
    Promise.all([isShowExposeBtn({}), fetchLatestExposeState({})]).then((results) => {
      setPortalExposeBtnProp({
        isShowExposeBtn: results[0].data,
        isShowNewText: results[1].data,
      });
    });
  }, []);
  // 在组件挂载时根据路由信息设置不同身份的跳转链接
  useEffect(() => {
    // 直接使用 location.href 获取完整的当前URL，更简单可靠
    const retUrl = location.href;
    setPurcharserRoute(`/sso/login?return_url=${encodeURIComponent(retUrl)}&role=purcharser`);
    setSupplierRoute(`/sso/xlogin?return_url=${encodeURIComponent(retUrl)}`);
  }, [router.asPath]); // 保持依赖项监听路由变化
  const isHideExposeBtn = userInfo?.currentUserType === CurrentUserTypeSource.personal;
  const selfOperatedOrganization = SelfOperatedOrganization();
  const isSupplier = amI(userInfo, 'supplier');
  const canShowEnquiry =
    !userInfo || (!selfOperatedOrganization && (IsExternalPurchaserUsed() || isSupplier));

  function handleWaypointEnter() {
    setSearchFixed(false);
  }
  function handleWaypointLeave() {
    setSearchFixed(true);
  }
  const { areaSysNo, setCookie, AREA_CODE_KEY, AREA_SYS_NO_KEY, setAreaObjByCookie } =
    useAreaCookie();

  // 地区修改时调用
  async function handleAreaChange(data: string[], reloadAreaInfo) {
    if (!data || !data?.length) return;
    // 根据市 查询最后一级地区信息
    let res = await getFirstTownOfCityCode(data[data.length - 1]);
    if (res?.code === 200 && res?.data) {
      setCookie(AREA_CODE_KEY, res.data.levelCode);
      setCookie(AREA_SYS_NO_KEY, res.data.sysNo);

      if (reloadAreaInfo) {
        setAreaObjByCookie();
      }

      // 刷新页面
      window.location.reload();
    }
  }
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <a target="_top" className="btn btn-primary" href={supplierRoute} title="企业或个人登录">
          企业或个人登录
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="1">
        <a target="_top" className="btn" href={purcharserRoute} title="中建三局内部登录">
          中建三局内部登录
        </a>
      </Menu.Item>
    </Menu>
  );

  const redirectExposurePage = () => {
    if (!userInfo) {
      handleLogin();
      return;
    }
    router.push(`/exposure`);
  };
  const toEnquiry = () => {
    router.push('/enquiry');
  };

  const portalURL =
    userInfo?.currentUserType === CurrentUserTypeSource.personal
      ? `/portal?perferKey=personal`
      : '/portal/';
  const [inDop, setInDop] = useState(false);

  const checkDopInfo = async () => {
    setInDop(await isInDop());
  };

  useEffect(() => {
    checkDopInfo();
  }, []);
  return (
    <Waypoint topOffset={-10} onEnter={handleWaypointEnter} onLeave={handleWaypointLeave}>
      <div className="head-content">
        <div className={cls(searchFixed && 'content-fixed')}>
          <Container>
            <div className="content">
              <div className="logo">
                <Link href={'/'}>
                  <a title="平台首页">
                    {navConfig?.logo?.[0]?.imageUrl ? (
                      <img
                        src={buildImgSrc(getPublicUrl(navConfig?.logo?.[0]?.imageUrl))}
                        alt="logo"
                      />
                    ) : (
                      <div className="logo-placeholder" />
                    )}
                  </a>
                </Link>
                <span className="sep" />
                {showAreaCascader && (
                  <div className="search-tab">
                    <div className="search-type-name">
                      {/* <span>{enumFilter(curSearchTab, SearchTypeEnum)}</span> */}

                      <div className="cascader">
                        <AreaCascader
                          placeholder="请选择"
                          value={areaSysNo}
                          areaLevel={2}
                          enableIPSwitch
                          curLevelAreaName
                          onChange={(data, reloadAreaInfo) =>
                            handleAreaChange(data, reloadAreaInfo)
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="search-box">
                <HeaderSearchInput hideSearchType={searchFixed} />
                {portalExposeBtnProp?.isShowExposeBtn && !isHideExposeBtn && (
                  <div className="baoguang" onClick={redirectExposurePage}>
                    <BaoGuangIcon />
                    <span style={{ marginLeft: '8px' }}>
                      {!portalExposeBtnProp.isShowNewText ? '曝光栏' : '曝光栏 new'}
                    </span>
                  </div>
                )}
                {canShowEnquiry && (
                  <div className="baoguang" onClick={toEnquiry}>
                    <EnquiryIcon />
                    <span style={{ marginLeft: '8px' }}>商务洽谈</span>
                  </div>
                )}
                {!userInfo && (
                  <div className="login">
                    <Dropdown overlay={menu} trigger={['hover']}>
                      <span
                        style={{
                          borderRight: '1px solid #ccc',
                          paddingRight: '11px',
                          cursor: 'pointer',
                          color: '#333',
                        }}
                      >
                        登录 <i className="iconfont icon-arrow-down" style={{ color: '#999' }} />
                      </span>
                    </Dropdown>
                    <a title="注册" className="register" href="/sso/reg" style={{}}>
                      注册
                    </a>
                  </div>
                )}
                {showCart &&
                  (userInfo?.isPurchaser ||
                    userInfo?.currentUserType === CurrentUserTypeSource.personal) && (
                    <div className="min-cart">
                      <HeaderMinCart>
                        <a className="cart-info" href="/shopping_cart">
                          <span className="cart-icon">
                            <i className="iconfont icon-gouwuche1" />
                          </span>
                          购物车
                          {quantity > 0 && (
                            <span className="quantity">
                              {quantity >= 99 || String(quantity).length > 5 ? '···' : quantity}
                            </span>
                          )}
                        </a>
                      </HeaderMinCart>
                    </div>
                  )}
                {!!userInfo && (
                  <div
                    className="baoguang"
                    title="工作台"
                    onClick={() => {
                      window.selfOpen(portalURL, inDop ? '_blank' : '_top');
                    }}
                  >
                    <ComputeIcon />
                    <span style={{ marginLeft: '8px' }}>工作台</span>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
        <style jsx>{`
          .head-content {
            padding: 24px 0;
          }
          :global(.ant-dropdown-menu-item):hover {
            color: #018DD7;
            background-color: rgba(0, 128, 255, 0.10);
          }
          .register {
            margin-left: 12px;
            cursor: pointer;
            color: #333;
          }
          .register:hover {
            color: #018DD7;
          }
          .content-fixed {
            height: 66px;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 10001;
            background-color: #fff;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
            animation: searchFixTop 0.5s ease;
            display: flex;
            align-items: center;
          }
          .content-fixed .logo {
            top: 13px;
          }
          .content-fixed .search-box {
            padding-top: 9px;
          }
          .content-fixed .min-cart {
            top: 9px;
          }
          .content-fixed .fast-order-btn {
            top: 9px;
          }
          .content {
            position: relative;
            display: flex;
            justify-content: space-between;
          }
          .logo {
            display: flex;
            align-items: center;
          }
          .sep {
            display: inline-block;
            margin: 0 16px;
            border-right: 1px solid #D9D9D9;
            height: 18px;
            vertical-align: middle;
          }
          .logo img {
            width: auto;
            height: 37px;
          }
          .logo-placeholder {
            width: 368px;
            height: 45px;
            background-color: #f6f6f6;
          }
          .search-box {
            // width: 754px;
            // padding-top: 41px;
            display: flex;
          }
          .quantity {
            border-radius: 2px;
            background: rgba(1, 141, 215, 0.10);
            padding: 0 4px;
            margin-left: 8px;
          }
          .baoguang {
            background-color: #F2F4F9;
            border-radius: 4px;
            display: flex;
            height: 36px;
            padding: 0px 18px;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #018DD7;
            margin-left: 12px;
            cursor: pointer;
          }
          .search-hot {
            height: 12px;
            line-height: 12px;
            margin-top: 10px;
          }
          .hot {
            font-size: 12px;
            color: #666666;
            font-weight: 400;
            margin-right: 10px;
          }
          .hot:hover {
            color: ${site?.global?.platformMainColor};
            text-decoration: underline;
          }
          .hot:last-child {
            margin-right: 0px;
          }
          .min-cart {
            margin-left: 12px;
          }
          .min-cart :global(.cart-box) {
            width: 100%;
            height: 36px;
            background: inherit;
            border: none;
            // background-image: url(${shopCartBtnBg})
          }
          .cart-info {
            height: 100%;
            color: #018DD7;
            font-size: 16px;
            line-height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #F2F4F9;
            border-radius: 4px;
            padding: 0 14px;
          }
          .cart-info .iconfont {
            font-size: 22px;
            margin-right: 8px;
          }
          @keyframes searchFixTop {
            0% {
              top: -60px;
            }
            100% {
              top: 0;
            }
          }
          .login {
            display: flex;
            height: 36px;
            padding: 0px 12px;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            background: #F2F4F9;
            margin-left: 12px;
          }
          .cascader :global(.cascader-hd-val) {
            width: auto;
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: right;
          }
        `}</style>
      </div>
    </Waypoint>
  );
}
